var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 0.833496C11.6597 0.833496 0.833008 11.6602 0.833008 25.0002C0.833008 38.3402 11.6597 49.1668 24.9997 49.1668C38.3397 49.1668 49.1663 38.3402 49.1663 25.0002C49.1663 11.6602 38.3397 0.833496 24.9997 0.833496ZM24.9997 8.0835C29.0113 8.0835 32.2497 11.3218 32.2497 15.3335C32.2497 19.3452 29.0113 22.5835 24.9997 22.5835C20.988 22.5835 17.7497 19.3452 17.7497 15.3335C17.7497 11.3218 20.988 8.0835 24.9997 8.0835ZM24.9997 42.4002C18.958 42.4002 13.6172 39.3068 10.4997 34.6185C10.5722 29.8093 20.1663 27.1752 24.9997 27.1752C29.8088 27.1752 39.4272 29.8093 39.4997 34.6185C36.3822 39.3068 31.0413 42.4002 24.9997 42.4002Z",
    fill: "#A5B4C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c25c72b646b4a0eea0b980cea489ae8b.svg";
export { ForwardRef as ReactComponent };